import { render, staticRenderFns } from "./ReviewOfPacking.vue?vue&type=template&id=0f6b2b7c"
import script from "./ReviewOfPacking.vue?vue&type=script&lang=js"
export * from "./ReviewOfPacking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports